/** Service Desk console: RMA replacement, pag-import ng lumang ticket at ang product funnel (SD-S4-06, SD-S4-07, SD-X-ANL-01). */
export const serviceRmaReplacement = {
  title: "Kapag natapos ang RMA bilang napalitan",
  intro: "Piliin kung ano ang itatala kapag minarkahang napalitan ang RMA ng kliyente. Para ito sa susunod na palit; ang mga nauna ay mananatili sa nakuha nila.",
  mode: {
    record: { label: "Itala lang (default)", hint: "Itala sa RMA at sa ticket nito na nakakuha ng kapalit mula sa stock ang kliyente. Walang order na gagawin." },
    order: { label: "Gumawa ng order na zero ang halaga", hint: "Maglalagay din ng order na 0.00 sa pangalan ng kliyente para makita ang kapalit sa kasaysayan ng order nila." },
  },
  neverSent: "Hindi kailanman ipinapadala ang alinman sa sariling sistema ng kliyente. Kung ilalagay ito ng team mo roon, mano-mano nila itong gagawin.",
  save: "I-save",
  saved: "Na-save ang setting ng kapalit",
  readOnly: "Mababasa mo ang setting na ito. Kailangan ng pahintulot na mag-manage ng asset para baguhin ito.",
  record: {
    title: "Kapalit",
    order: "Order na zero ang halaga",
    stock: "Pinalitan mula sa stock",
    openOrder: "Order {{number}}",
    orderHint: "Inilagay sa pangalan ng kliyente sa halagang 0.00. Hindi ito ipinadala sa sistema ng kliyente.",
    product: "Produkto",
    sku: "SKU",
    serial: "Serial number",
    quantity: "Dami",
    recorded: "Naitala",
    error: "Hindi ma-load ang kapalit.",
  },
  fallback: {
    no_profile: "Walang commerce profile ang workspace, kaya itinala ang kapalit sa halip na gumawa ng order.",
    no_organisation: "Walang organisasyon ang RMA, kaya itinala ang kapalit sa halip na gumawa ng order.",
    no_contact: "Walang contact na puwedeng mag-order ang organisasyon, kaya itinala ang kapalit sa halip na gumawa ng order.",
  },
} as const;

export const serviceImportHistory = {
  points: {
    quiet: "Walang pagsasabihan. Walang e-mail, push o bell item na pupunta sa kliyente o staff, at walang aanunsyo ang mga ticket.",
    sla: "Walang SLA clock na magsisimula. Nananatili ang lumang petsa ng mga na-import na ticket at hindi sila magbi-breach o mag-e-escalate. Puwedeng humingi ng timer ang isang row gamit ang column na sla_timers; tatakbo lang ito kung bukas pa ang ticket.",
    idempotent: "Ligtas patakbuhin ulit. Ang external_id ng bawat row ay ang id nito sa lumang sistema: nilalaktawan ang row na nandoon na at hindi kailanman isinusulat ulit ang na-import na ticket.",
    dates: "Nananatili ang lumang petsa. Pinananatili ang oras ng paggawa, pag-update, pagresolba at pagsara ayon sa ibinigay (UTC maliban kung may offset ang petsa).",
  },
  upload: {
    title: "Pag-import ng kasaysayan, hindi bagong trabaho",
    formats: "Isang CSV, o JSON lines (.jsonl): isang ticket bawat linya, kasama ang mga mensahe nito. Mag-validate muna: inililista ng dry run ang bawat error sa row at walang isinusulat.",
    dropTitle: "I-drop dito ang CSV o JSON lines na file",
    dropHint: "UTF-8, hanggang {{size}} MB at {{rows}} ticket. Ang unang row ng CSV ay ang mga pangalan ng column.",
    choose: "Pumili ng file",
  },
  validate: { title: "Dry run: walang isinusulat, walang pagsasabihan" },
  done: { title: "Tahimik na na-import", openTickets: "Buksan ang mga ticket" },
} as const;

export const serviceProductFunnel = {
  label: "Mga bilang ng product funnel",
  weekOf: "Linggo ng {{date}}",
  kpi: {
    intake: "Pagtatapos ng intake",
    intakeSub: "{{submitted}} naipasa sa {{started}} nasimulan",
    portal: "Mga sign-in sa portal",
    portalSub: "mga kliyenteng nagbukas ng portal",
    conversion: "Cart patungong order",
    conversionSub: "{{orders}} order mula sa {{carts}} cart",
    quotes: "Pagtanggap ng quote",
    quotesSub: "{{accepted}} tinanggap sa {{requested}} hiniling",
  },
  step: {
    intake_started: "Nasimulan ang intake",
    intake_submitted: "Naipasa ang intake (nabuksan ang ticket)",
    deflected: "“Nasolusyunan nito”",
    portal_opened: "Sign-in sa portal",
    cart_started: "Nasimulan ang cart",
    order_placed: "Nailagay ang order",
    quote_requested: "Hiniling ang quote",
    quote_accepted: "Tinanggap ang quote",
    visit_window_chosen: "Napili ang oras ng pagbisita",
    acceptance_done: "Tinanggap ang installation",
  },
  steps: {
    title: "Product funnel",
    sub: "Mga hakbang ng mga kliyente, {{period}}",
    column: "Hakbang",
    count: "Beses",
    rate: "Rate",
  },
  weeks: {
    title: "Funnel kada linggo",
    sub: "Intake at mga order kada linggo, {{period}}",
    column: "Linggo",
    conversion: "Cart patungong order",
  },
} as const;
